import React from 'react'

import { useStyles } from './map-feature.style'
import { colors } from '../../common/colors'

export const MapFeature = ({ pathDefinition, color, isSelected, className, showOutline = true, enableMouseEvents = true, onMouseOver, onClick }) => {
  const classes = useStyles()
  return (
    <path
      d={pathDefinition}
      fill={color || colors.silver}
      onMouseOver={onMouseOver}
      onClick={onClick}
      className={`${showOutline ? classes.feature : classes.featureWithoutOutline} ${isSelected ? classes.selected : ''} ${enableMouseEvents ? '' : classes.disableMouseEvents} ${className}`}
    />
  )
}
